"use client";

import { forwardRef } from "react";

interface SwiperButtonProps {
  direction: "prev" | "next";
  isDisabled: boolean;
  className?: string;
  onClick?: () => void;
  "aria-label"?: string;
}

const SwiperButton = forwardRef<HTMLButtonElement, SwiperButtonProps>(
  (
    { direction, isDisabled, className = "", onClick, "aria-label": ariaLabel },
    ref,
  ) => {
    const baseClassName = `z-4 absolute cursor-pointer top-1/2 hidden -translate-y-1/2 bg-white p-3 shadow shadow-gray-400 transition-opacity duration-300 md:block ${
      isDisabled ? "pointer-events-none opacity-0" : "opacity-100"
      }`;

    const positionClassName =
      direction === "prev"
        ? "-left-4 rounded-r-[8px]"
        : "-right-4 rounded-l-[8px]";

    const iconContent = direction === "prev" ? "\\e912" : "\\e911";

    const finalClassName =
      `${baseClassName} ${positionClassName} ${className}`.trim();

    return (
      <button
        ref={ref}
        className={finalClassName}
        onClick={onClick}
        aria-label={
          ariaLabel || `${direction === "prev" ? "Previous" : "Next"} slide`
        }
      >
        <i
          className={`icomoon md:text-[16px] text-xs before:font-bold before:text-[#FF6700] before:content-['${iconContent}']`}
        ></i>
      </button>
    );
  },
);

SwiperButton.displayName = "SwiperButton";

export default SwiperButton;
